import React from "react";
import Step1 from "../steps/section-4/step-1";
import Step2 from "../steps/section-4/step-2";
import Step3 from "../steps/section-4/step-3";
import Step4 from "../steps/section-4/step-4";
import Step5 from "../steps/section-4/step-5";

function TeamReportsSection4({
  step = 1,
  incomeStatement,
  netRevenues = 0,
  costOfSales = 0,
  rndCosts = 0,
  promotionCosts = 0,
  sellingCosts = 0,
  current_year = 0,
  data = {},
  teams = {},
  total_demand = {},
  endingInventory = 0
}) {
  if (step === 1) {
    return <Step1 />;
  }

  if (step === 2) {
    return (
      <Step2
        data={data}
        teams={teams}
        total_demand={total_demand}
        endingInventory={endingInventory}
      />
    );
  }

  if (step === 3) {
    return (
      <Step3
        incomeStatement={incomeStatement}
        netRevenues={netRevenues}
        costOfSales={costOfSales}
        current_year={current_year}
      />
    );
  }

  if (step === 4) {
    return (
      <Step4
        incomeStatement={incomeStatement}
        rndCosts={rndCosts}
        promotionCosts={promotionCosts}
        current_year={current_year}
      />
    );
  }

  if (step === 5) {
    return (
      <Step5
        incomeStatement={incomeStatement}
        sellingCosts={sellingCosts}
        current_year={current_year}
      />
    );
  }

  return null;
}

export default TeamReportsSection4;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-4.js